module.exports = __webpack_public_path__ + "static/news-thumb-2-29954d427dbca6dc5b587603313507b4.png";